
const common = {
  "leaderboard.list.column.players": "Jugadores",
  "leaderboard.list.column.score": "Puntuación",
  "leaderboard.list.column.rank": "Rango",
  "leaderboard.list.column.rating": "Calificación",

  "leaderboard.user-rank-not-available": "No tienes un rango aún",
  "leaderboard.table-rank": "Tabla de Rangos · {{ rank }}",
};

const filters = {
  "leaderboard.filters.general": "General",
  "leaderboard.filters.metrics": "Métricas",
  "leaderboard.filters.location": "Ubicación",
  "leaderboard.location.global": "Global",
  "leaderboard.location.country": "Mi país",
  "leaderboard.location.continent": "Mi continente",
  "leaderboard.location.missing.title": "Define tu ubicación para desbloquear rankings locales",
  "leaderboard.location.missing.description": "Agrega tu país en tu perfil para compararte con jugadores cercanos.",
  "leaderboard.location.cta": "Editar perfil",
  "leaderboard.filters.age": "Edad",
  "leaderboard.age-group.all": "Todos",
  "leaderboard.age-group.u12": "Menores de 12",
  "leaderboard.age-group.u16": "Menores de 16",
  "leaderboard.age-group.u21": "Menores de 21",
  "leaderboard.age-group.senior": "Senior",
  "leaderboard.age-group.missing.title": "Define tu fecha de nacimiento para desbloquear rankings por edad",
  "leaderboard.age-group.missing.description": "Agrega tu fecha de nacimiento en tu perfil para compararte con jugadores de tu grupo de edad.",
  "leaderboard.age-group.cta": "Editar perfil",
  "leaderboard.profile-incomplete.missing.title": "Completa tu perfil",
  "leaderboard.profile-incomplete.missing.description": "Agrega tu país y fecha de nacimiento para desbloquear rankings locales y por grupo de edad.",
  "leaderboard.no-results": "No se encontraron jugadores para los filtros seleccionados",
};
export const leaderboard = {
  ...common,
  ...filters,
};
